interface IInputBase {
  label?: string;
  error?: string;
  as?: "input" | "textarea";
}

interface IInput
  extends IInputBase,
    React.InputHTMLAttributes<HTMLInputElement> {
  as?: "input";
}

interface ITextarea
  extends IInputBase,
    React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  as: "textarea";
}

type InputProps = IInput | ITextarea;

const Input = (inputProps: InputProps) => {
  const { label, error, id, as = "input", ...props } = inputProps;
  const type = (inputProps as IInput).type || "text";
  const inputId = id || label?.toLowerCase().replace(/\s+/g, "-");

  const baseClassName = `w-full p-4 border rounded-xl outline-none transition-colors ${
    error
      ? "border-error-500 focus:border-error-500"
      : "border-neutral-400 focus:border-neutral-600"
  }`;

  return (
    <div className="w-full flex flex-col gap-1 relative">
      {label && (
        <label htmlFor={inputId} className="text-[18px] font-bold">
          {label}
        </label>
      )}
      {as === "textarea" ? (
        <textarea
          id={inputId}
          className={baseClassName}
          {...(props as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
        />
      ) : (
        <input
          id={inputId}
          type={type}
          className={baseClassName}
          {...(props as React.InputHTMLAttributes<HTMLInputElement>)}
        />
      )}
      {error && (
        <span className="text-[16px] font-bold text-error-500">{error}</span>
      )}
    </div>
  );
};

export default Input;
